import Profile from './Profile'
import ProfileUpdate from './Update'
import ProfileAuthenticate from './Authenticate'
import ProfileShebaNumbers from './ShebaNumbers'
import ProfileAddresses from './Addresses'
import ProfileChangPassword from './change-password'
import ProfileNamad from './Namad'
export {
    Profile,
    ProfileUpdate,
    ProfileAuthenticate,
    ProfileShebaNumbers,
    ProfileAddresses,
    ProfileChangPassword,
    ProfileNamad
}